var map = {
	"./asset-hyperlink.json": 223502,
	"./blockquote.json": 597784,
	"./document.json": 494634,
	"./embedded-asset-block.json": 396188,
	"./embedded-entry-block.json": 374160,
	"./embedded-entry-inline.json": 233290,
	"./embedded-resource-block.json": 197904,
	"./embedded-resource-inline.json": 927242,
	"./entry-hyperlink.json": 640830,
	"./heading-1.json": 682713,
	"./heading-2.json": 633036,
	"./heading-3.json": 58399,
	"./heading-4.json": 521634,
	"./heading-5.json": 418317,
	"./heading-6.json": 162800,
	"./hr.json": 428381,
	"./hyperlink.json": 861203,
	"./list-item.json": 834421,
	"./ordered-list.json": 213867,
	"./paragraph.json": 986311,
	"./resource-hyperlink.json": 407272,
	"./table-cell.json": 685156,
	"./table-header-cell.json": 828132,
	"./table-row.json": 553388,
	"./table.json": 445825,
	"./text.json": 854084,
	"./unordered-list.json": 51464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485152;